export const imageUrls = {
    military: "https://storage.ninestarunited.com/Military/hero.png",
    graphics: "https://storage.ninestarunited.com/Graphics/hero.png",
    musicSchool: "https://storage.ninestarunited.com/MusicSchool/hero.png",
    realEstate: "https://storage.ninestarunited.com/Real%20Estate/hero.png"
  };
  